module.exports = __webpack_public_path__ + "static/GooseBumps_Screenshots_Slappy_5.5-inch-retina-d912c8209d6703401be2d1c61bfdebd6.jpg";